import React, {useState, useContext, useRef, useEffect} from 'react';
import { useIonRouter, IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonFooter, IonAlert } from '@ionic/react';
import { IonImg, IonLabel } from '@ionic/react';
import {Plugins, CameraResultType } from '@capacitor/core';

import { useHistory} from "react-router-dom";

import '../../../css/layout.css';
import PublicShowcaseModal from '../components/AccountSetting_publicShowcase';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { UpdatePayMethod_CheckingModal } from '../../../appsecure_components/Modal_UpdatePayMethod_Checking';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import { PayModal_Subscription } from '../../../zInternal_Features/merchant/components/Modal_Pay_Subscription';

import { Preferences } from '@capacitor/preferences'


function setFunction_tutorial(event) {


    //alert("in SET FUNCTION TUTORIAL");
    //alert(event);

    Preferences.set({
        key: 'selected_tutorial',
        //value: event,
        value: JSON.stringify({
            tutorial_id: event[0],
            tutorial_name: event[1],
            details: event[2],
            status: event[3],
            dateCreated: event[4],
            lastModified: event[5],
        })

    })

}

const { Filesystem } = Plugins;
const { Camera } = Plugins;


//export class Hotel_AccountSetting extends React.Component {
export function Retail_Tutorials () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    let [ bookingType, setBookingType ] = useState('online');

    let [viewTutorialsList, setViewTutorialsList] = useState([]);

    let [disable_viewImages, setDisable_viewImages] = useState(true);

    let [ tutorial_id, setTutorial_id ] = useState(authenticatedMerchent_context.selectedTutorial.tutorial_id);
    let [ tutorial_name, setTutorial_name ] = useState(authenticatedMerchent_context.selectedTutorial.tutorial_name);
    let [ tutorial_details, setTutorial_details ] = useState(authenticatedMerchent_context.selectedTutorial.details);
    let [ tutorial_status, setTutorial_status ] = useState(authenticatedMerchent_context.selectedTutorial.status);
    let [ tutorial_dateCreated, setTutorial_dateCreated ] = useState(authenticatedMerchent_context.selectedTutorial.dateCreated);
    let [ tutorial_lastModified, setTutorial_lastModified ] = useState(authenticatedMerchent_context.selectedTutorial.lastModified);

    let [showPrompt, setShowPrompt] = useState(false);
    let [selectedEvent, setSelectedEvent] = useState(null);


    let [isloading, setLoading] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    function getTutorials(event)
    {
       // alert('In GET TUTORIALS Setting ');

       // setViewTutorialsList([]);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "33_retrieveTutorials",
                    user: acctID,
                    sessionID: sessionID,

    
                }),
            }


            //alert("IN SELLECT ROOOM");
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {


                            setViewTutorialsList([]);

                            let rows = res.toString().split('~~~');
    
                            let rowLength = rows.length;


    
                                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                                {
                                    let cols = rows[rownum].split('|');

                                    setViewTutorialsList((prevSetViewTutorialsList) => {
                                        return prevSetViewTutorialsList.concat({
                                            id: cols[0],
                                            name: cols[1],
                                            details: cols[2],
                                            status: cols[3],
                                            dateCreated: cols[4],
                                            lastModified: cols[5],
                                        })
                
                                    });
    
                                }

                                setLoading(false);

                            
                        }, 'html')
    };

    // function getTutorialDetails(event)
    // {


    
    //         setTutorial_id(event[0]);
    //         setTutorial_name(event[1]);
    //         setTutorial_details(event[2]);
    //         setTutorial_status(event[3]);
    //         setTutorial_dateCreated(event[4]);
    //         setTutorial_lastModified(event[5]);




    // }

    function getTutorialDetails(event) {


        setSelectedEvent(event);  // store the clicked event temporarily
        setShowPrompt(true);      // show the confirmation prompt
      }


    function confirmTutorialSelection(event)
    {

       // setViewTutorialsList([]);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "33_tutorial_confirmSelection",
                    user: acctID,
                    xTutorialID: event[0],
                    xTutorialDetails: event[2],
                    sessionID: sessionID,

    
                }),
            }


            //alert("IN SELLECT ROOOM");
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                            let rows = res.toString().split('~~~');
    
                            let rowLength = rows.length;

                            let cols = rows[0].split('|');

                            //setFunction_tutorial([event[0], event[1], cols[0], cols[1], event[4], event[5]]);

                            let selectedTutorialParsed = {};
                
                            try {
                            selectedTutorialParsed = JSON.stringify({
                                setup_id: event[0],
                                name: event[1],
                                details: cols[0],
                                status: cols[1],
                                dateCreated: event[4],
                                lastModified: event[5],
                            })
                                ? JSON.parse(JSON.stringify({
                                    setup_id: event[0],
                                    namne: event[1],
                                    details: cols[0],
                                    status: cols[1],
                                    dateCreated: event[4],
                                    lastModified: event[5],
                                })) : {};
            
                            if (typeof selectedTutorialParsed.details === 'string') {
                                selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
                            }
                            } catch (e) {
                            console.warn('Error parsing selectedTutorial:', e);
                            selectedTutorialParsed = {};
                            }
            
            
                         //authenticatedMerchent_context.changeSelectedTutorial(selectedTutorialParsed); 
                         setFunction_tutorial([event[0], event[1], cols[0], cols[1], event[4], event[5]]);

                         //alert("TUTORIAL SET.  PLEASE FOLLOW THE FLASHING GUIDES.");

                        //history.push('/retail_merchantMainPageApp');
                        setTimeout(() => {
                            //event.detail.complete();   // Stop the spinner
                            //window.location.reload();  // Reload the entire app
                            //history.push('/retail_merchantMainPageApp');
                            //router.push('/retail_merchantMainPageApp', 'forward', 'replace');
                            window.location.href = '/retail_merchantMainPageApp';
                          }, 500);

                
            });
    };


    function resetTutorialList(event)
    {

       // setViewTutorialsList([]);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "33_tutorial_reset",
                    user: acctID,
                    sessionID: sessionID,

    
                }),
            }


            //alert("IN SELLECT ROOOM");
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                            //alert(res);

                            let parsed = authenticatedMerchent_context.selectedTutorial.details;

                            for (const [key, value] of Object.entries(parsed)) {
                                console.log(`${key} = ${value}`);
                                
                                if (value === false) {
                                    parsed[key] = true;
                                }
                            }

                            let jsonString_details = JSON.stringify(parsed);  // e.g., '{"step_1":true,"step_2":true,...}'

                            //alert(jsonString_details);

                            setFunction_tutorial([tutorial_id, tutorial_name, jsonString_details, 'PENDING', tutorial_dateCreated, tutorial_lastModified]);

                            //history.push('/retail_merchantMainPageApp');
                            setTimeout(() => {
                                //event.detail.complete();   // Stop the spinner
                                //window.location.reload();  // Reload the entire app
                                //history.push('/retail_merchantMainPageApp');
                                //router.push('/retail_merchantMainPageApp', 'forward', 'replace');
                                window.location.href = '/retail_merchantMainPageApp';
                              }, 500);
                            
                        })
    };

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        history.push(event);
        //window.location.pathname = event;

    }

    useEffect(() => {

        getTutorials();

    }, [])
    

    return (
            <React.Fragment>
          
            {/*<App_Header></App_Header>*/}

            <IonHeader style={{color: 'white'}}>
                <IonGrid>
                    {authenticatedMerchent_context.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left' }} size='4'>
                            <IonTitle >{authenticatedMerchent_context.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left' }} size='6'>
                            <IonTitle >{authenticatedMerchent_context.employeeFirstName + ' ' + authenticatedMerchent_context.employeeLastName}</IonTitle>
                        </IonCol>
                        <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton className="custom-menu-button"  fill={'clear'}>M</IonMenuButton>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        <IonCol>
                            <h3>TUTORIALS</h3>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent className='grid_content'>

            <IonAlert
                isOpen={showPrompt}
                onDidDismiss={() => setShowPrompt(false)}
                header="Load Tutorial?"
                message="Do you want to load this tutorial?"
                buttons={[
                    {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        setShowPrompt(false);
                    }
                    },
                    {
                    text: 'Yes',
                    handler: () => {
                        if (selectedEvent) {
                        setTutorial_id(selectedEvent[0]);
                        setTutorial_name(selectedEvent[1]);
                        setTutorial_details(selectedEvent[2]);
                        setTutorial_status(selectedEvent[3]);
                        setTutorial_dateCreated(selectedEvent[4]);
                        setTutorial_lastModified(selectedEvent[5]);
                        }

                        confirmTutorialSelection(selectedEvent);
                        setShowPrompt(false);
                    }
                    }
                ]}
                />
                      

                <IonGrid>
                    <IonRow>
                        <IonCol size='12'> MAKE SELECTION</IonCol>
                    </IonRow>
                </IonGrid>
                <IonGrid>
                    {viewTutorialsList.map(tutorial => (

                            <IonRow   
                                onClick={() => getTutorialDetails([tutorial.id, tutorial.name, tutorial.details, tutorial.status, tutorial.dateCreated, tutorial.lastModified])}
                                style={{
                                    cursor: 'pointer',
                                    margin: '8px 0',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    backgroundColor: tutorial.status === 'SELECTED' ? '#90EE90' : '#ffffff',
                                    border: tutorial.status === 'SELECTED' ? '2px solid #2ecc71' : '1px solid #ccc',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                  }}
                                >
                                <IonCol size='12'>
                                    {tutorial.name}
                                </IonCol>
                            </IonRow>
                            ))}

                </IonGrid>
            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                        <IonRow>
                            <IonCol size='6'>
                                <IonButton onClick={() => resetTutorialList()}> Reset </IonButton>
                            </IonCol>
                            <IonCol size='6'>
                                <IonButton onClick={() => handleRoute('/retail_merchantMainPageApp')}> Close </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
            </IonFooter>

            </React.Fragment>
            
    );
};



export default Retail_Tutorials;